import Vue from 'vue'
import { GET_SECTORS } from '../mutation-types.js'

export const getSectors = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('sector')
    .then(
      (response) => {
        dispatch(GET_SECTORS, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/sectorsActions.js